export default __webpack_public_path__ + "static/media/pic2.d8caf0c4.png";